import React, { Fragment, useMemo, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import { PDFDocument } from 'pdf-lib';

import Loader from "../Loader/Loader.jsx";
// import Loader from "../../Loader/Loader.jsx";
import { useStore } from "../../hook-store/store.js";
import { ollamaMcpPdfToText } from "../../utils/ollama/pdf-file.js";
import { uploadLargeFileForProcess } from "../../utils/large-file-upload-utils/large-file-upload-utils.js";

import { 
  ollamaNodeJsUrl,
  loginPageLink,
  signupPageLink,
} from "../../App.js";

import { marks } from "../../utils/marks.jsx";
import "./PdfToTextAction.css";
// import { marks } from "../../../utils/marks.jsx";


export default function PdfToTextAction(props) {
    const { 
      inputPdfFile,
      setPdfTextData,
      pdfMetadata,
      setIsLoading,
      pdfToTextConfig,
      uploadApp,
      isLoading,
      // pdfTextData,
    } = props;


    const [t] = useTranslation("translation");

    const [store, dispatch] = useStore();
    const { isAuth } = store.uiStore;
    const { 
      usageBasedConfig,
      usageBasedSubscription,
      usageBasedValidMethod,
      usageBasedPrice,
    } = store.stripeData;
    const { 
      isPdfToTextServerBusy,
    } = store.pdfToTextStore;


    const [errorMessage, setErrorMessage] = useState('');


    const pdfToTextHandler = async (pdfFile) => {
      try {
        setIsLoading(true);
        setErrorMessage('');

        const resData = await ollamaMcpPdfToText(
          ollamaNodeJsUrl,
          localStorage.getItem('token'),
          pdfFile,
          localStorage.getItem('customerId'),
          usageBasedPrice?.id,
          localStorage.getItem('userId'),
          pdfFile.name,
        );

        console.log(resData);
        
        if (resData.data.data) {
          setPdfTextData(resData.data.data);
        }

        setIsLoading(false);
      } catch(err) {
        console.log(err);
        setIsLoading(false);
        setErrorMessage('PDF to text failed.');
        throw err;
      }
    };

    const pdfToTextHandler2 = async (pdfFile) => {
      try {
        setIsLoading(true);
        setErrorMessage('');

        // const resData = await ollamaMcpPdfToText(
        //   ollamaNodeJsUrl,
        //   localStorage.getItem('token'),
        //   pdfFile,
        //   localStorage.getItem('customerId'),
        //   usageBasedPrice?.id,
        //   localStorage.getItem('userId'),
        //   pdfFile.name,
        // );

        let priceId;

        if (usageBasedPrice) {
          priceId = usageBasedPrice.id;
        }

        const dataForProcess = {
          userId: localStorage.getItem('userId'),
          filename: pdfFile.name,
          uploadApp: uploadApp, 
          processAction: 'pdfToText',
          // totalFileNum: totalFileNum,
          // fileIdx: fileIdx,
        };

        const response = await uploadLargeFileForProcess(
          ollamaNodeJsUrl,
          `/ollama-mcp/pdf-to-text2`,
          localStorage.getItem('token'),
          pdfFile,
          5*10**6,
          localStorage.getItem('customerId'),
          priceId,
          dataForProcess,
        );

        if (!response.ok) {
          throw new Error('error occured');
        }

        const resData = await response.json();
        console.log(resData);
        
        if (resData.data.data) {
          setPdfTextData(resData.data.data);
        }

        setIsLoading(false);

        dispatch('SHOW_NOTIFICATION', {
          status: '',
          title: `${t('audioTranscriber45', 'file processing')} ${t('audioTranscriber46', 'success')}`,
          message: '',
        });

        setTimeout(() => {
          dispatch('CLEAR_NOTIFICATION');
        },1000 * 10);

      } catch(err) {
        console.log(err);
        setIsLoading(false);
        setErrorMessage('PDF to text failed.');

        dispatch('SHOW_NOTIFICATION', {
          status: 'error',
          title: `${t('audioTranscriber45', 'file processing')} ${t('audioTranscriber48', 'failed')}`,
          message: '',
        });
        
        throw err;
      }
    };

        // let selectedLngModels = [];
    let genButtonDisabled = false;
    let genButtonText = `stt-gen-button-text`;
    let isUsageBased = false;
    let isUsageBasedOk = true;
    let ubbUnit = 0;
    let pttFreeMaxPage = 0;

    if (pdfToTextConfig && pdfToTextConfig.pttFreeMaxPage) {
      if (pdfToTextConfig.pttFreeMaxPage > 0) {
        pttFreeMaxPage = pdfToTextConfig.pttFreeMaxPage;
      }
    }



    if (isLoading || !inputPdfFile || !pdfMetadata || !pdfToTextConfig || isPdfToTextServerBusy) {
      genButtonDisabled = true;
    }

    if (pdfMetadata && pdfMetadata.pageCount > pttFreeMaxPage) {
      isUsageBased = true;

      if (pdfToTextConfig && usageBasedConfig && usageBasedConfig.pdfToTextUnit) {
        const useUnit = Math.round((pdfMetadata.pageCount - pttFreeMaxPage) * usageBasedConfig.pdfToTextUnit);
        
        // console.log('useUnit', useUnit);
        if (useUnit > 0) {
          ubbUnit = useUnit
        }
      }
    }



    if (isUsageBased && 
        (!isAuth || !usageBasedSubscription || !usageBasedValidMethod)
    ) {
      isUsageBasedOk = false;
      genButtonDisabled = true;
    }

    // console.log('isUsageBased, isUsageBasedOk, ubbUnit', isUsageBased, isUsageBasedOk, ubbUnit);
    




    let pdfToTextActionBody;

    pdfToTextActionBody = (
      <div>
        {/* {isPdfToTextServerBusy ? 'ptt-server-busy' : 'not-ptt-server-busy'} */}
        {inputPdfFile && (
          <div>

            {pdfMetadata && pdfMetadata.pageCount && (
              <div className='pdfToTextRow'>
                <strong>
                  {pdfMetadata.pageCount}
                  {' '}{t('pdfToText06', 'pages')}
                </strong>
                {' '}({inputPdfFile.name})
              </div>
            )}


            {ubbUnit > 0 && (
              <div className='pdfToTextRow'>
                Unit{' '}
                <strong>
                  {ubbUnit}
                  {' '}
                  ({(Number(usageBasedPrice.unit_amount_decimal)/100*ubbUnit).toFixed(2)} USD)
                </strong>
              </div>
            )}

          {isUsageBased && !isAuth && (
            <div>
              <div className='pdfToTextRow'>
                <strong>
                  {t('pdfToText07', 'For PDF file with more than one pages, User need to enable usage based billing after login.')}
                </strong>
                {' '}(~0.01 USD)
              </div>
              <div className='pdfToTextRow'>
                <a href={loginPageLink}>
                  <button className="btnBase">
                    {marks.signInMrak} {t('aboutAuth06', 'Login')}
                  </button>
                </a>
                <span> or </span>
                <a href={signupPageLink}>
                  <button className="btnBase">
                    {marks.userPlusMrak} {t('aboutAuth07', 'Signup')}
                  </button>
                </a>
              </div>
            </div>
          )}

          {isUsageBased && usageBasedPrice && usageBasedConfig && (
            <div>
              <div className='pdfToTextRow'>
                <strong>
                  {t('pdfToText08', 'Because text generation from pdf file uses a lot of resources, payment is required.')}
                  (more than {pttFreeMaxPage} pages,
                  {' '}~{Number(usageBasedPrice.unit_amount_decimal)/100*usageBasedConfig.speechToTextUnit} USD)
                </strong>
              </div>
            </div>
          )}


          {isUsageBased && isAuth && !usageBasedSubscription && (
            <div className='pdfToTextRow'>
              <div>
                <strong>
                  {t('voiceGenerator19', 'Enabling usage based billing is required.')}
                </strong>
              </div>
              <Link
                to="/usage-based-billing"
              >
                <button className='btnBase'>
                  {t('voiceGenerator20', 'Go to usage based billing page')}
                </button>
              </Link>
            </div>
          )}

          {isUsageBased && isAuth && usageBasedSubscription && !usageBasedValidMethod && (
            <div className='pdfToTextRow'>
              <div>
                <strong>
                  {t('voiceGenerator21', 'Card information for payment is required.')}
                </strong>
              </div>
              <Link
                to="/usage-based-billing"
              >
                <button className='btnBase'>
                  {t('voiceGenerator20', 'Go to usage based billing page')}
                </button>
              </Link>
            </div>
          )}

            <div className="pdfToTextRow">
              <button className="pdfToTextActionButton"
                style={{}}
                disabled={isLoading || genButtonDisabled}
                onClick={() => {
                  // console.log(URL.createObjectURL(inputPdfFile))
                  // pdfToTextHandler(inputPdfFile)
                  pdfToTextHandler2(inputPdfFile)
                }}
              >
                {t('pdfToText09', 'Create text from pdf')}
              </button>
              {isPdfToTextServerBusy && (
                <div>busy...</div>
              )} 

              {isLoading && (
                <Loader />
              )}
              {errorMessage && (
                <div className="pdfToTextActionErrorMessage">
                  {errorMessage}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );

    return (
        <Fragment>
          <div>{pdfToTextActionBody}</div>
        </Fragment>
    );
  };
